import config from './configure'
/**
 *
 * @type {{hasErr: (function(*))}}
 */
let common = {
  /**
   * 判定请求是否成功
   * @param rsp
   * @returns {*|boolean}
   */
  hasErr: (rsp) => {
    return (rsp && rsp.code && parseInt(rsp.code) === 0 && rsp.state && rsp.state === 'success')
  },
  /**
   * 获取结果值
   * @param rsp
   * @returns {*}
   */
  getRsp: (rsp) => {
    return rsp
  },
  /**
   * 获取返回结果的消息
   * @param rsp
   * @returns {string|string}
   */
  getMsg: (rsp) => {
    return rsp.msg
  },
  /**
   * 存储cookie
   * @param name键名 value键值
   * @returns {*}
   */
  setCookie: (name, value) => {
    document.cookie = name + '=' + escape(value) + ';path=/'
  },
  /**
   * 获取cookie
   * @param name键名
   * @returns {string}
   */
  getCookie: (name) => {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    var arr = document.cookie.match(reg)
    if (arr !== null) {
      return unescape(arr[2])
    }
    return null
  },
  /**
   * 删除cookie
   * @param name键名
   * @returns {*}
   */
  delCookie: (name) => {
    let value = common.getCookie(name)
    if (value !== null) {
      let exp = new Date()
      exp.setTime(exp.getTime() - 10000)
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
    }
  },
  /**
   * 保存登录信息
   * @param data
   * @returns {*}
   */
  setUserInfo: (data) => {
    let user = data || {}
    common.setCookie(config.cookie_prefix + 'access_token', user.token)
    common.setCookie(config.cookie_prefix + 'user_info', JSON.stringify(user))
  },
  /**
   * 获取登录信息
   * @param *
   * @returns {object}
   */
  getUserInfo: () => {
    let user = common.getCookie(config.cookie_prefix + 'user_info') || '{}'
    return JSON.parse(user)
  },
  /**
   * 获取ip信息
   * @param *
   * @returns {object}
   */
  getCityInfo: () => {
    let cityInfo = common.getCookie(config.cookie_prefix + 'city_info') || '{}'
    return JSON.parse(cityInfo)
  },
  /**
   * 获取用户是否是说客用户
   * @param data
   * @returns {*}
   */
  setFirstLogin: (firstLogin) => {
    let userInfoStr = common.getCookie(config.cookie_prefix + 'user_info') || '{}'
    let userInfo = JSON.parse(userInfoStr)
    common.setCookie(config.cookie_prefix + 'user_info', JSON.stringify({
      ...userInfo,
      firstLogin: firstLogin
    }))
  },
  setPerInfo: (data) => {
    let user = data || {}
    common.setCookie(config.cookie_prefix + 'person_info', user.info.talkUser)
  },
  // 用户名
  setName: (data) => {
    let userName = data || {}
    common.setCookie(config.cookie_prefix + 'userName', userName)
  },
  getName: () => {
    let userName = common.getCookie(config.cookie_prefix + 'userName') || ''
    return userName
  },
  /**
   * 保存用户是否是说客用户
   * @param *
   * @returns {object}
   */
  getUserSimpleInfo: () => {
    let personInfo = common.getCookie(config.cookie_prefix + 'person_info') || '{}'
    return JSON.parse(personInfo)
  },
  /**
   * 获取用户头像
   * @param data
   * @returns {*}
   */
  setUserImg: (data) => {
    let img = data || {}
    common.setCookie(config.cookie_prefix + 'person_img', img)
  },
  /**
   * 保存用户是否是说客用户
   * @param *
   * @returns {object}
   */
  getUserImg: () => {
    let personImg = common.getCookie(config.cookie_prefix + 'person_img') || '{}'
    return personImg
  },
  /**
   * 清除登录信息
   * @param *
   * @returns {*}
   */
  clearUserInfo: () => {
    common.delCookie(config.cookie_prefix + 'access_token')
    common.delCookie(config.cookie_prefix + 'user_info')
    common.delCookie(config.cookie_prefix + 'city_info')
    common.delCookie(config.cookie_prefix + 'person_img')
  },
  formatTime (v) {
    let t = v
    let num = t % 60
    let a = String(t / 60).split('.')[0]
    let b = num < 10 ? '0' + num.toFixed() : num.toFixed()
    let m = a < 10 ? '0' + a + ':' + b : a + ':' + b
    return m
  }
}

export default common



// WEBPACK FOOTER //
// ./src/global/common.js